import { doc, getDoc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';
import Table from '@src/models/Table';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToTableByDivision,
  getRouteToTableByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class TableRepository {
  constructor() {
    this.table = new Table();
  }

  getCollectionPath(orgId, divId = null, boardId) {
    if (divId) {
      return getRouteToTableByDivision(orgId, divId, boardId);
    }
    return getRouteToTableByOrg(orgId, boardId);
  }

  async create({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.table.setData(data);
      const res = await createOperation(collectionPath, null, this.table, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId, tableId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.table.setData(data);
      const tableData = this.table.toUpdate();
      await createOperation(collectionPath, tableId, tableData, ACTIONS.UPDATE);
      return tableData;
    }).catch(error => {
      throw error;
    });
  }

  async delete({ orgId, divId = null, boardId, tableId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      await createOperation(collectionPath, tableId, null, ACTIONS.DELETE);
      return { id: tableId };
    }).catch(error => {
      throw error;
    });
  }

  async get({ orgId, divId = null, boardId, tableId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const tableRef = doc(db, collectionPath, tableId);
      const tableDoc = await getDoc(tableRef);
      
      if (tableDoc.exists()) {
        return { id: tableDoc.id, ...tableDoc.data() };
      }
      return null;
    }).catch(error => {
      throw error;
    });
  }
}

export default TableRepository;
